import React from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RowList from 'main/components/show/cuesheet.prompter/rowPanelList';
import TrackingSelector from 'main/components/show/cuesheet.prompter/trackingSelector.jsx';
import classNames from 'classnames';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import Button from 'shared/components/misc/button.jsx';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class RowPanel extends React.Component {
  constructor(props) {
    super(props);
    this._toggleRowPanelDisplay = this._toggleRowPanelDisplay.bind(this);
  }

  componentDidMount() {
    /**
     * When user initially loads the prompter view we close the row
     * panel after three seconds if they don't hover over or interact with
     * it.
     */
    this._initialDisplayTimeout = setTimeout(() => {
      this._togglePanelDisplay(false);
    }, 3000);
  }

  render() {
    const { open, width } = this.props;

    return (
      <div
        id="fullscreen-rows-panel-wrapper"
        className={classNames({ open: open, 'close-panel': !open })}
      >
        <div className="flex flex-row flex-grow-1">
          <div id="fullscreen-rows-panel">
            <div className="flex-row">
              <div className="flex-column row-list-wrapper">
                <RowList {...this.props} />
              </div>
            </div>
            <div style={{ width }} className="flex-row">
              <div
                className="flex-column"
                id="fullscreen-rows-panel-tracking-selector-wrapper"
              >
                <TrackingSelector
                  onToggleTrackingEnabled={
                    FullScreenCuesheetActions.toggleTrackingEnabled
                  }
                  onSelectTrackableUser={
                    FullScreenCuesheetActions.selectTrackableUser
                  }
                  iconRight="angle-down"
                  {...this.props}
                />
                <Button
                  className="teleprompter-close-btn"
                  onClick={this._toggleRowPanelDisplay}
                >
                  <Icon name="arrow-circle-left" />
                  Close
                </Button>
              </div>
            </div>
          </div>
          <div className="tab-container left">
            <div
              id="left-fullscreen-tab"
              onClick={this._toggleRowPanelDisplay}
            />
          </div>
        </div>
      </div>
    );
  }

  _toggleRowPanelDisplay() {
    const { open } = this.props;
    FullScreenCuesheetActions.togglePanel('rowPanel', !open);
  }

  _togglePanelDisplay(display) {
    if (display && this._initialDisplayTimeout) {
      clearTimeout(this._initialDisplayTimeout);
      delete this._initialDisplayTimeout;
    }

    const clearPanelTimeout = () => {
      clearTimeout(this._hidePanelTimeout);
      delete this._hidePanelTimeout;
    };

    if (this._hidePanelTimeout) {
      clearPanelTimeout();
    }

    /**
     * Add a three second delay to modal closing
     */
    if (display === false) {
      this._hidePanelTimeout = setTimeout(() => {
        FullScreenCuesheetActions.togglePanel('rowPanel', display);
        clearPanelTimeout();
      }, 500);
    } else {
      FullScreenCuesheetActions.togglePanel('rowPanel', display);
    }
  }
}

export default RowPanel;
